module.exports = __webpack_public_path__ + "static/media/randa.7ba9ab60.jpg";